import { createAction, props } from '@ngrx/store';
import { VerifyChallengeOutput } from '@smash-sdk-private/captcha/ejs/10-2025';

export const VerifyCaptcha = createAction(
  '[Captcha] Verify Captcha',
  props<{ token: string, action: string }>()
);

export const VerifyCaptchaSuccess = createAction(
  '[Captcha] Verify Captcha Success',
  props<{ result: VerifyChallengeOutput['challenge']['status'] }>()

);

export const VerifyCaptchaFailure = createAction(
  '[Captcha] Verify Captcha Failure',
  props<{ error: string }>()
);

export const StartVerifyCaptcha = createAction(
  '[Captcha] Start Verify Captcha',
)

export const ResetVerifyCaptcha = createAction(
  '[Captcha] Verify Captcha Reset',
)
